import { h } from 'preact';
import { t } from '../theme/locales';
export const Button = ({ className ='Product-embroideryButton' , ariaControls ='embroidery-modal' , dataModalOpen , innerLabel =t('embroidery.button_label') , innerLabelPrice =t('embroidery.button_price') , onModalOpen , isExpanded =false  })=>{
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!dataModalOpen) return;
        const el = document.getElementById(dataModalOpen);
        if (onModalOpen) onModalOpen(el);
    };
    const inner = [
        h('span', {}, innerLabel),
        h('div', {
            className: 'Product-embroideryButton-price'
        }, h('span', {}, innerLabelPrice), h('span', {}, h('svg', {
            width: '8',
            height: '12',
            viewBox: '0 0 8 12',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            'aria-hidden': 'true'
        }, h('path', {
            d: 'M1.5 1L6.5 6L1.5 11',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
        }))))
    ];
    return h('button', {
        className,
        type: 'button',
        'aria-controls': ariaControls,
        'aria-expanded': isExpanded,
        'data-testid': 'Product-embroideryButton',
        onClick: handleClick
    }, ...inner);
};
export default Button;
